import set from "@rill/set";
import ReadinessRate from "./readiness/ReadinessRate";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import _ from "lodash";

const ReadinessRateController = (app) => {
  app.get(
    "/readiness-rate",
    set("heading", "Readiness Rate"),
    async ({ req, res, locals, load }) => {
      const isAllowToViewAllOrganizationsAthletes =
        locals.organizationRoleName &&
        (locals.organizationRoleName === "Owner" ||
          locals.organizationRoleName === "Admin");

      if (
        locals.activeUser.organizationId &&
        isAllowToViewAllOrganizationsAthletes &&
        !locals.allAthletesFromOrganization
      ) {
        await load("allAthletesFromOrganization");
      }
      const modal = _.get(req.query, "modal", {});
      locals.modal = {
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = <ReadinessRate />;
    }
  );
};

export default ReadinessRateController;
